<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="undefined" sm="3" xs="2">
        <v-simple-table dense width="120px">
          <tr>
            <td style="text-align: right; padding0; margin: 0;width:20%">
              <v-img :src="require('../assets/under_const.png')" width="64px" />
            </td>
            <td style="overflow: hidden;text-align: left; padding: 0; margin: 0;width:80%">
              <span class="overline">Constructing...</span>
            </td>
          </tr>
        </v-simple-table>
        <h3>RESTful Web API</h3>
        <div class="text-body-1 font-italic">
          Host securely in your office and get dynamic content anywhere!
        </div>
      </v-col>
      <v-col justify-center cols="8" sm="6" xs="8">
        <v-card class="justify-center mx-auto" id="noBackground" elevation="0" max-width="300px" min-width="285px">
          <v-img :src="require('../assets/logo.png')" />
        </v-card>
        <v-container class="text-h2">
          <span :class="['grey--text','font-weight-light']">dev</span>Sentinel<span class="grey--text"> .</span><span :class="['text-h4','red--text','font-weight-light']">CSSS</span>
        </v-container>
        <div class="subtitle-1">
          <i>"Building localized business software in the Philippines"</i>
        </div>
        <v-card-subtitle>
          <h3> Stay Safe@Home
            <br>
            Stop Corona Virus!
          </h3>
        </v-card-subtitle>
      </v-col>
      <v-col cols="undefined" sm="3" xs="2">
        <!-- class="blue-grey white--text"-->
        <v-simple-table dense width="120px">
          <tr>
            <td style="text-align: right; margin: 0;width:20%">
              <v-img :src="require('../assets/under_const.png')" width="64px" />
            </td>
            <td style="overflow: hidden;text-align: left; padding: 0; margin: 0;width:80%">
              <h3>PRODUCT CATALOGS</h3>
              <span class="overline">Under Construction...</span>
            </td>
          </tr>
        </v-simple-table>
        <!--h3>Products</h3>
          <div class="text-body-1 font-italic  text-justify">
            Accounting System for EC
            <ul>
              <li>General Ledger
                <ul  class="dashed">
                  <li  v-for="(item, index) in GLItems " :key="index">
                    {{item.Title}}
                  </li>
                </ul>
              </li>
              <li>Billing
                <ul  class="dashed">
                  <li  v-for="(item, index) in BItems " :key="index">
                    {{item.Title}}
                  </li>
                </ul>
              </li>
              <li>Warehousing
                <ul  class="dashed">
                  <li  v-for="(item, index) in WHItems " :key="index">
                    {{item.Title}}
                  </li>
                </ul>
              </li>
            </ul>

            Email: admin@devsentinel.com
          </div-->
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'

export default {
  name: 'HomeContent',
  /*data: () => ({
    GLItems: [
      {Title:'CDCR Register'},
      {Title:'Check Register'},
      {Title:'Sales Register'},
      {Title:'Accounts Payable'},
      {Title:'Adjustment Journal'},
      {Title:'Check Printing'},
      {Title:'Financial Reports'},
      {Title:'Accounting Period Protection'},
      {Title:'See more...'}
    ],
    BItems: [
      {Title:'On Field Read and Bill (Android" & "Windows Mobile)'},
      {Title:'Reading Data Uploading via Wifi'},
      {Title:'Bill Adjustments'},
      {Title:'Automated Sales T-Account Entry'},
      {Title:'Sales Supporting Details'},
      {Title:'Consumers Welfare Support'},
      {Title:'See more...'}
    ],
    WHItems: [
      {Title:'Inventory'},
      {Title:'Receiving Reports'},
      {Title:'Material Requisition'},
      {Title:'Material Charge Ticket'},
      {Title:'Support Automated T-Account Entry'},
      {Title:'See more...'}
    ]
  })*/
}
</script>
<style scoped>
ul {
  margin: 0;
}

ul.dashed {
  list-style-type: none;
}

ul.dashed>li {
  text-indent: -5px;
}

ul.dashed>li:before {
  content: "-";
  text-indent: -5px;
}
</style>